var exports = {
  "kL": "xdbfd91f1--5936ca--container",
  "S3": "xdbfd91f1--5936ca--content_container",
  "wx": "xdbfd91f1--5936ca--header",
  "e3": "xdbfd91f1--5936ca--image_container",
  "YG": "xdbfd91f1--5936ca--header-icon",
  "BJ": "xdbfd91f1--5936ca--header-title",
  "h_": "xdbfd91f1--5936ca--description",
};

module.exports = exports;
